export default __webpack_public_path__ + "c9e7e88c4291cd957e24360bc902225f.png";